/*
  LOULEX-Anpassung (#31): Verhalten von <loulex-cross-sell> (snippets/loulex-cross-sell.liquid).
  Das Hinzufügen selbst läuft über Prestiges <product-form> aus theme.js: fetch auf /cart/add.js,
  danach variant:add und cart:change; der Drawer öffnet sich über on_success=force_open_drawer und
  rendert seine Section neu.

  1. Farbauswahl: select "id" mit den verfügbaren Varianten. Die Karte zieht Bild und bei
     abweichenden Preisen den Preis nach. Eine Wahl von Hand merkt sich die Karte (data-picked).

  2. Farbabgleich (nur mit Attribut form-id, also auf der Produktseite): variant:change des
     Hauptformulars wählt in jeder nicht von Hand geänderten Karte die Variante mit demselben
     Optionswert. Gibt es die Farbe nicht, bleibt die Auswahl.

  3. Bestätigung: variant:add aus einer Karte markiert sie (data-added), der Button zeigt
     „Hinzugefügt“, bis die Seite neu lädt.

  4. Warenkorb (nur Produktseite; der Drawer rendert serverseitig neu): cart:change blendet Karten
     aus, deren Produkt anderweitig in den Warenkorb kam, und wieder ein, sobald es entfernt ist.
     Gerade hinzugefügte Karten bleiben mit ihrer Bestätigung stehen. Ohne sichtbare Karte ist der
     ganze Block verborgen.

  5. Fehler aus cart:error (z. B. Bestand) stehen in der Karte, bis erneut abgeschickt wird.

  Der Konstruktor liest keine Attribute (Upgrade-Pfad). Nach einem Theme-Update prüfen, ob
  variant:change (detail.variant.options), variant:add, cart:change (detail.cart.items) und
  cart:error (detail.error) noch so heißen.
*/
(function () {
  'use strict';

  if (window.customElements.get('loulex-cross-sell')) return;

  var ITEM = '.loulex-cross-sell__item';
  var CHOICE = 'select[name="id"]';

  class LoulexCrossSell extends HTMLElement {
    connectedCallback() {
      this.loulexAbort = new AbortController();
      var options = { signal: this.loulexAbort.signal };

      this.addEventListener('change', this.loulexOnChoice.bind(this), options);
      this.addEventListener('variant:add', this.loulexOnAdded.bind(this), options);
      this.addEventListener('cart:error', this.loulexOnError.bind(this), options);
      this.addEventListener('submit', this.loulexOnSubmit.bind(this), { signal: this.loulexAbort.signal, capture: true });

      if (this.hasAttribute('form-id')) {
        document.addEventListener('variant:change', this.loulexOnVariantChange.bind(this), options);
        document.addEventListener('cart:change', this.loulexOnCartChange.bind(this), options);
      }
    }

    disconnectedCallback() {
      if (this.loulexAbort) this.loulexAbort.abort();
    }

    loulexOnChoice(event) {
      var select = event.target;
      if (!select.matches(CHOICE)) return;

      var item = select.closest(ITEM);
      if (!item) return;

      item.setAttribute('data-picked', '');
      this.loulexShow(item, select.selectedOptions[0]);
    }

    loulexOnVariantChange(event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== this.getAttribute('form-id')) return;

      var variant = event.detail && event.detail.variant;
      if (!variant || !Array.isArray(variant.options)) return;

      this.querySelectorAll(ITEM).forEach(function (item) {
        var select = item.querySelector(CHOICE);
        if (!select || item.hasAttribute('data-picked')) return;

        var match = Array.prototype.find.call(select.options, function (option) {
          return variant.options.indexOf(option.dataset.value) !== -1;
        });

        if (match && !match.selected) {
          select.value = match.value;
          this.loulexShow(item, match);
        }
      }, this);
    }

    loulexOnAdded(event) {
      var item = event.target.closest(ITEM);
      if (!item) return;

      item.setAttribute('data-added', '');

      var button = item.querySelector('.loulex-cross-sell__button');
      if (button && button.dataset.addedLabel) button.setAttribute('aria-label', button.dataset.addedLabel);
    }

    loulexOnCartChange(event) {
      var cart = event.detail && event.detail.cart;
      if (!cart || !Array.isArray(cart.items)) return;

      var inCart = cart.items.map(function (line) { return String(line.product_id); });
      var visible = 0;

      this.querySelectorAll(ITEM).forEach(function (item) {
        item.hidden = !item.hasAttribute('data-added') && inCart.indexOf(item.dataset.productId) !== -1;
        if (!item.hidden) visible++;
      });

      this.hidden = visible === 0;
    }

    loulexOnSubmit(event) {
      var item = event.target.closest(ITEM);
      var error = item && item.querySelector('.loulex-cross-sell__error');
      if (error) error.hidden = true;
    }

    loulexOnError(event) {
      var item = event.target.closest(ITEM);
      var error = item && item.querySelector('.loulex-cross-sell__error');
      var message = event.detail && (event.detail.error || event.detail.message);
      if (!error || !message) return;

      error.textContent = message;
      error.hidden = false;
    }

    loulexShow(item, option) {
      if (!option) return;

      var price = item.querySelector('[data-price]');
      if (price && option.dataset.price) price.innerHTML = option.dataset.price;

      var image = item.querySelector('.loulex-cross-sell__image');
      if (!image || !option.dataset.src || image.currentSrc === option.dataset.src) return;

      var done = function () { image.classList.remove('is-loading'); };
      image.classList.add('is-loading');
      image.addEventListener('load', done, { once: true });
      image.addEventListener('error', done, { once: true });
      image.srcset = option.dataset.srcset || '';
      image.src = option.dataset.src;
    }
  }

  window.customElements.define('loulex-cross-sell', LoulexCrossSell);
})();
